import React from 'react';
import semver from 'semver';
import Status from 'components/status';

export default function InstalledAppStatus({ installedApp, onClickUpdate }) {
  const { parent_id, environment_id, app, active, version } = installedApp;

  const isPrivate = !app.published && app.client_id === parent_id;

  const availableVersion = isPrivate
    ? app.version
    : app.published_props?.version;

  const updateAvailable =
    version && semver.compare(availableVersion, version) > 0;

  return (
    <>
      {active === false ? (
        <Status type="muted">Disabled</Status>
      ) : (
        updateAvailable && (
          <a href="" onClick={onClickUpdate}>
            <Status type="primary">Update available</Status>
          </a>
        )
      )}
      {version === null && environment_id === 'test' ? (
        <Status type="warning">Development</Status>
      ) : (
        isPrivate && <Status type="muted">Private</Status>
      )}
    </>
  );
}
